/** VistoeraTASK-00342 — shared Generate Video slot drag-over contract.
 * ONE compatibility source for connection-drag highlighting and tests;
 * delegates to `validateDropZoneTarget` (same rules as `onConnect`). */

import { validateDropZoneTarget } from './dataflow'

const noopT = ((key: string) => key) as Parameters<typeof validateDropZoneTarget>[3]

/** True when `sourceNodeType` may connect to this semantic `targetHandle`
 * on `generate_video` (never file-extension heuristics). */
export function isGenerateVideoDropTargetCompatible(
  sourceNodeType: string,
  targetHandle: string,
): boolean {
  return validateDropZoneTarget(sourceNodeType, 'generate_video', targetHandle, noopT).ok
}
